// extracted by mini-css-extract-plugin
export default {"container":"ChatBotVideo_container__tlk12","icons":"ChatBotVideo_icons__zD5T4","playPause":"ChatBotVideo_playPause__tFTCp","fullScreen":"ChatBotVideo_fullScreen__IHRxq"};